import React from 'react';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import SectionTitle from "./SectionTitle";

const ShumaType10Title = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const title = (
    <>
      <span>{context.sectionNumbers.section10}</span>
      <span>. השומה</span>
    </>
  );

  return (
    <SectionTitle title={title} ref={ref}/>
  );
});

export default ShumaType10Title;
